const riot = require('riot');

riot.tag2('page-distribution_events-single', '<div class="s-full min-height-100per" show="{event}"> <div class="f fclm container-538 s-full"> <div show="{event.selected_point_provider}" data-is="module-provider-{event.selected_point_provider}" event="{event}" onetime-hash="{onetimeHash}" account-link-qr-code="{accountLinkQrCode}"></div> <div class="mb48" show="{!event.selected_point_provider}" ref="select_provider" data-is="module-select-provider" providers="{getProviderOptions()}" amount="{event.amount}" expires-at="{event.expires_at}"></div> <module-footer class="bg-gray_05 pt32 pb20 px24 mta" event="{event}" is-hide-terms="{event.point_provider === &quot;paypay&quot;}"></module-footer> </div> </div>', 'page-distribution_events-single,[data-is="page-distribution_events-single"]{display:block}', '', function(opts) {
    this.preload = async ({req, res}) => {
      const onetime_hash = req.query.hash;
      if (!onetime_hash) throw { status: 404 };
      try {

        const event = await app.api.child('distribution_event').get({
          onetime_hash,
        });

        if (event.received_at) {
          res.redirect(301, `/thanks?hash=${onetime_hash}`);
          return ;
        }

        else if (event.transfer_requested_at) {
          res.redirect(301, `/receive?hash=${onetime_hash}`);
          return ;
        }

        if (event.selected_point_provider) {
          let preload_result = await app.utils.preloadModuleProvider(event.selected_point_provider, onetime_hash);
          this.update(preload_result);
        }

        return {
          event,
          onetimeHash: onetime_hash
        };
      }
      catch(e) {
        if (e.status === 404) {
          e.customMessage = '有効期限がきれているか、受取済みの可能性があります。';
        }
        throw e;
      }
    };

    this.head = () => {
      return {
        title: '受け取り画面 | Repro Incentive',
      };
    };

    this.on('mount', () => {
      this.refs.select_provider.on('selectProvider', async (e) => {
        try {
          let _event = await app.api.child('distribution_event/select_point_provider').post({
            onetime_hash: this.onetimeHash,
            point_provider: e.value
          });
          this.event = _event;
          this.update();

          try {
            let preload_result = await app.utils.preloadModuleProvider(e.value, this.onetimeHash);
            this.update(preload_result);
          }
          catch (err) {
            console.error(err);
            spat.modal.alert('エラーが発生しました。再度ページをリロードしてください。');
          }
        }
        catch (err) {
          console.error(err);
          spat.modal.alert('エラーが発生しました。再度受け取るポイント種別をご選択ください。');
        }
      })
    })

    this.getProviderOptions = () => {
      return  app.data.constants.point_providers.filter((provider) => this.event.point_providers.includes(provider.id));
    };
});